import type React from 'react';
import styled from 'styled-components';

import { mediaConfined, mediaWide } from '@xing-com/layout-tokens';
import {
  SkeletonBodyCopy,
  SkeletonHeadline,
  SkeletonProfileImage,
  SkeletonTag,
} from '@xing-com/skeleton';
import { scale410, spaceL, spaceM, spaceS, spaceXL } from '@xing-com/tokens';

import { SearchContentContainer } from '../search-content-container';

const ProfileInfoWrapper = styled.article`
  display: flex;
  padding: ${spaceL} 0;
  margin: ${spaceM};

  @media ${mediaWide} {
    margin: ${spaceL};
    width: 80%;
  }
`;

const SkeletonHeadlineWrapper = styled.div`
  flex-grow: 1;
  margin-left: ${spaceM};
`;

const StyledSkeletonHeadline = styled(SkeletonHeadline)`
  margin-bottom: ${spaceM};
`;

const FiltersContainer = styled.div`
  max-width: ${scale410};
`;

const TagsContainer = styled.div`
  display: flex;
  gap: ${spaceS};
  padding: ${spaceS} ${spaceM} ${spaceXL} 0;
`;

const Headline = styled(SkeletonHeadline)`
  margin-bottom: ${spaceM};
  width: 300px;

  @media ${mediaConfined} {
    margin-bottom: ${spaceL};
  }
`;

const LargerSkeletonTag = styled(SkeletonTag)`
  @media ${mediaConfined} {
    width: 130px;
  }
`;

export const ResultsSkeleton: React.FC = () => {
  return (
    <div data-testid="search-results-loading-skeleton">
      <Headline size="medium" sizeConfined="large" amountRows={1} />
      {Array.from({ length: 10 }, (_, i) => (
        <ProfileInfoWrapper key={i}>
          <SkeletonProfileImage
            size="small"
            sizeConfined="medium"
            sizeWide="large"
          />
          <SkeletonHeadlineWrapper>
            <StyledSkeletonHeadline
              alignment="left"
              amountRows={1}
              size="medium"
            />
            <SkeletonBodyCopy alignment="left" amountRows={3} />
          </SkeletonHeadlineWrapper>
        </ProfileInfoWrapper>
      ))}
    </div>
  );
};

const FiltersSkeleton: React.FC = () => {
  return (
    <>
      {Array.from({ length: 3 }, (_, i) => (
        <FiltersContainer key={i}>
          <SkeletonHeadline size="small" sizeConfined="medium" amountRows={1} />
          <TagsContainer>
            <LargerSkeletonTag />
            <SkeletonTag />
            <SkeletonTag />
          </TagsContainer>
        </FiltersContainer>
      ))}
    </>
  );
};

export const SearchLoadingSkeleton: React.FC = () => (
  <SearchContentContainer
    dataTestid="search-loading-skeleton"
    filters={<FiltersSkeleton />}
    results={<ResultsSkeleton />}
  />
);
